import { render } from "./AddEditPrvComponent.vue?vue&type=template&id=5bab0829"
import script from "./AddEditPrvComponent.vue?vue&type=script&lang=js"
export * from "./AddEditPrvComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__